import { onMounted, onUnmounted } from 'vue'

export function usePolling(fn: () => void | Promise<void>, interval = 3000) {
  let timer: number | undefined
  let isRunning = false

  /** 启动轮询（防止重复启动） */
  function start() {
    if (isRunning) return
    isRunning = true
    fn() // 立即执行一次
    timer = window.setInterval(fn, interval)
  }

  /** 停止轮询 */
  function stop() {
    if (timer) {
      clearInterval(timer)
      timer = undefined
    }
    isRunning = false
  }

  /** 页面可见性控制（后台暂停） */
  function handleVisibilityChange() {
    if (document.hidden) stop()
    else start()
  }

  onMounted(() => {
    start()
    document.addEventListener('visibilitychange', handleVisibilityChange)
  })

  onUnmounted(() => {
    stop()
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })

  // 返回手动控制函数
  return { start, stop }
}
